import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useParams, Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function UserProfile() {
  const { id } = useParams();
  const [u, setU] = useState(null);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get(`/users/${id}`).then(r => setU(r.data));
    api.get(`/posts/user/${id}`).then(r => setPosts(r.data));
  }, [id]);

  if (!u) return <div className="max-w-3xl mx-auto px-6 py-20 text-slate-500">Loading…</div>;

  return (
    <div className="max-w-3xl mx-auto px-6 py-12" data-testid="user-profile-page">
      <div className="card-flat p-8 flex flex-col sm:flex-row gap-6 items-start">
        <div className="w-24 h-24 rounded-full bg-[#002855] text-[#C5A059] font-display text-4xl flex items-center justify-center">{u.name?.[0]}</div>
        <div className="flex-1">
          <h1 className="font-display text-3xl text-[#0A192F]">{u.name}</h1>
          <div className="text-sm text-slate-600">{u.agency || "—"} · Cohort {u.cohort_year || "—"}</div>
          {u.bio && <p className="mt-3 text-slate-700 leading-relaxed">{u.bio}</p>}
          <Link to={`/messages/${u.id}`} className="inline-block mt-5">
            <Button className="bg-[#002855] hover:bg-[#0A192F] text-white rounded-md" data-testid="message-user-button">Message</Button>
          </Link>
        </div>
      </div>

      <div className="mt-10">
        <div className="label-eyebrow">Recent posts</div>
        <div className="mt-4 space-y-3">
          {posts.length === 0 && <div className="text-slate-500 text-sm">No posts yet.</div>}
          {posts.map(p => (
            <div key={p.id} className="card-flat p-5">
              <div className="text-sm text-slate-800 whitespace-pre-line">{p.content}</div>
              <div className="mt-3 text-xs text-slate-400">{p.likes_count} likes · {p.comments_count} comments</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
